import {
  Button,
  Field,
  Stack,
  InputGroup,
} from '@chakra-ui/react';
import { LuLock } from 'react-icons/lu';
import { useState } from 'react';
import PasswordInput from '@/components/PasswordInput';
import AuthContainer from '@/components/AuthContainer';
import { useNavigate } from 'react-router'
import ConfirmActionDialog from '@/components/ConfirmActionDialog'
import useForm from './useForm'

const NewPassword = () => {
  const [password, setPassword] = useState('');

  const navigate = useNavigate()
  const { onSubmit, isPending, showConfirmation, validationErrors } = useForm();

  return (
    <AuthContainer
      subtitle="Insira abaixo sua nova senha."
    >
      <form onSubmit={onSubmit}>
        <Stack gap="5">
          <Field.Root invalid={!!validationErrors?.new_password}>
            <Field.Label>Senha</Field.Label>
            <InputGroup startElement={<LuLock />} width="full" gap={0}>
              <PasswordInput
                name="new_password"
                placeholder="••••••••"
                minLength={8}
                variant="subtle"
                bg="gray.200"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </InputGroup>
            {validationErrors?.new_password?.map((error, index) => (
              <Field.ErrorText key={index}>{error}</Field.ErrorText>
            ))}
          </Field.Root>
          <Field.Root>
            <Field.Label>Confirmar senha</Field.Label>
            <InputGroup startElement={<LuLock />} width="full" gap={0}>
              <PasswordInput name="confirmPassword" placeholder="••••••••" minLength={8} variant="subtle" bg="gray.200" required />
            </InputGroup>
          </Field.Root>

          <Button
            type="submit"
            loading={isPending}
            disabled={isPending}
          >
            Redefinir
          </Button>
        </Stack>
      </form>
      {showConfirmation && (
        <ConfirmActionDialog
          open
          onOpenChange={() => navigate('/', { replace: true })}
          title="Senha redefinida!"
          body="Sua senha foi atualizada com sucesso. Faça login para continuar."
          onConfirm={() => navigate('/', { replace: true })}
          confirmLabel="Fazer login"
          hideCancelButton
          size="md"
        />
      )}
    </AuthContainer>
  );
};

export default NewPassword;
